import {
  GetConfigJobFamiliesResponse,
  UpdateJobFamiliesConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsJobFamiliesService = {
  async list(): Promise<GetConfigJobFamiliesResponse> {
    const response = await httpClient.get<GetConfigJobFamiliesResponse>(
      "v1/config/internal-grade/job-families",
    );
    return response;
  },
  async update(body: UpdateJobFamiliesConfig): Promise<void> {
    await httpClient.patch("v1/config/internal-grade/job-families", body);
  },
};

export default ConfigurationsJobFamiliesService;
